import React, { FC, Fragment, useEffect, useState } from 'react';
import {
    Card,
    Form as AntForm,
    Descriptions,
    Alert,
    Rate,
    Spin,
    Button,
    Empty,
    Radio,
    InputNumber,
    message,
    Icon,
    Modal,
} from 'antd';
import { Image } from '@comall-backend-builder/components-basis';
import { FormComponentProps } from 'antd/es/form';
import { Entity } from '@comall-backend-builder/core/lib/parser';
import { services } from '@comall-backend-builder/core';
import DetailTitle from '../DetailTitle';
import { errorHandle } from '../../services';
import { isArray } from 'lodash';
import './index.less';

const api = services.api;

export interface CategoryFilterAttrTableProps {
    entity: Entity;
    params: any;
    componentId: string;
    form: FormComponentProps['form'];
}
export const SunbathingEditDom: FC = (props: any) => {
    const params = props.params || {};
    const id = params.id || '';
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState<any>({});
    const [reply, setReply] = useState<any>({ hideCount: '', showCount: '' });
    const [replyList, setReplyList] = useState<any[]>([]);
    const [showStatus, setShowStatus] = useState(''); //显示状态
    const [sortValue, setSortValue] = useState(0); // 排序值
    const [secondaryShowStatus, setSecondaryShowStatus] = useState('');
    const [showPreview, setShowPreview] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const ImageProps = {
        text: '品真阁',
        style: {
            width: '150px',
        },
    };

    // 获取详情信息
    const handlleGetDetail = () => {
        setLoading(true);
        api.get({}, { apiPath: `/review_list/detail/${id}` })
            .then((res: any) => {
                setDetail(res);
                console.log(res.showStatus, 'res.showStatus');
                setShowStatus(res.showStatus ?? '');
                setSortValue(res.sortValue ?? '');
                setSecondaryShowStatus(res.secondaryShowStatus ?? '');
            })
            .catch(errorHandle)
            .finally(() => {
                setLoading(false);
            });
    };

    // 获取详情信息
    const handlleGetReply = () => {
        api.get({ page: 1, perPage: 5000 }, { apiPath: `/review_list/reply/${id}` })
            .then((res: any) => {
                const { hideCount, result, showCount } = res;
                setReply({ hideCount, showCount });
                setReplyList(result);
            })
            .catch(errorHandle);
    };

    useEffect(() => {
        handlleGetDetail();
        handlleGetReply();
        return () => {
            sessionStorage.setItem('fromSunbathingOrder', 'true');
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChangeShowStatus = (e: any) => {
        setShowStatus(e.target.value);
    };

    const handleChangeSecondaryshowstatus = (e: any) => {
        setSecondaryShowStatus(e.target.value);
    };

    const handleChangeSortValue = (value: React.SetStateAction<number>) => {
        setSortValue(value);
    };

    const goBack = () => {
        services.navigation.goto('/content/sunbathingOrder');
    };

    const handleChangeReplyList = (e: any, index: any) => {
        const newReplyList = [...replyList];
        newReplyList[index].replyStatus = e.target.value;
        setReplyList(newReplyList);
    };

    const handelSave = () => {
        if (!sortValue) {
            message.warning('排序值不能为空');
            return;
        }
        const replyListId = replyList.map((item: any) => {
            return {
                replyStatus: item.replyStatus,
                replyId: item.id,
            };
        });
        const params = {
            sortValue,
            showStatus,
            secondaryShowStatus,
            replyList: replyListId,
        };
        api.put(params, { apiPath: `/review_list/reply/${id}` })
            .then(() => {
                message.success('保存成功！');
                services.navigation.goto('/content/sunbathingOrder');
            })
            .catch(errorHandle);
    };

    const handlePreview = (item: any) => {
        setPreviewImage(item);
        setShowPreview(true);
    };

    return (
        <Fragment>
            <Spin spinning={loading}>
                <div className="sunbathing-edit-dom">
                    <Card title="基本信息" extra={<Button onClick={goBack}>返回</Button>}>
                        <DetailTitle label={'基本信息'} />
                        <Descriptions>
                            <Descriptions.Item label="显示状态">
                                <Radio.Group onChange={handleChangeShowStatus} value={showStatus}>
                                    <Radio value={0}>显示</Radio>
                                    <Radio value={1}>隐藏</Radio>
                                </Radio.Group>
                            </Descriptions.Item>
                            <Descriptions.Item label="排序">
                                <InputNumber
                                    value={sortValue}
                                    max={999}
                                    min={1}
                                    precision={0}
                                    placeholder="请输入数值"
                                    onChange={handleChangeSortValue}
                                />
                            </Descriptions.Item>
                            <Descriptions.Item label="是否追评">
                                {detail.secondaryStatus === 1 ? '已追评' : '未追评'}
                            </Descriptions.Item>
                            <Descriptions.Item label="会员账户">
                                {detail.loginName || '--'}
                            </Descriptions.Item>
                            {/* <Descriptions.Item label="微信昵称">{'--'}</Descriptions.Item> */}
                            <Descriptions.Item label="会员等级">
                                {detail.memberLevelName ?? '--'}
                            </Descriptions.Item>
                            <Descriptions.Item label="评价sku">
                                {detail.skuCode || '--'}
                            </Descriptions.Item>
                            <Descriptions.Item label="商品款号">
                                {detail.styleCode || '--'}
                            </Descriptions.Item>
                            <Descriptions.Item label="商品名称">
                                {detail.skuName || '--'}
                            </Descriptions.Item>
                            <Descriptions.Item label="评分">
                                <Rate disabled value={detail.star} />
                            </Descriptions.Item>
                            <Descriptions.Item label="获得点赞">
                                <Icon type="heart" style={{ marginRight: '4px' }} />
                                {detail.praiseCount ?? '--'}
                            </Descriptions.Item>
                        </Descriptions>
                        <DetailTitle label={'晒单内容'} />
                        <Card>
                            <Descriptions>
                                <Descriptions.Item className="time-style" label="发布时间">
                                    {detail.createTimeStr || '--'}
                                </Descriptions.Item>
                            </Descriptions>
                            <div style={{ whiteSpace: 'pre-line', lineHeight: 1.8 }}>
                                {detail.content ? detail.content.replace(/ /g, '\u00a0') : '--'}
                            </div>
                            {detail.picList && isArray(detail.picList) && (
                                <div>
                                    {detail.picList.map((item: any, index: React.Key) => (
                                        <div
                                            key={index}
                                            className="image-box"
                                            onClick={() => handlePreview(item)}
                                        >
                                            <Image imageurl={item!} {...ImageProps} />
                                        </div>
                                    ))}
                                </div>
                            )}
                        </Card>

                        {Number(detail.secondaryStatus) === 1 && (
                            <Card style={{ margin: '20px 0' }}>
                                <div className="alert-box">
                                    <Alert
                                        message={`${detail.secondaryInterval}天后追评`}
                                        type="info"
                                        style={{
                                            width: '120px',
                                            textAlign: 'center',
                                            marginBottom: '8px',
                                        }}
                                    />

                                    <Radio.Group
                                        onChange={handleChangeSecondaryshowstatus}
                                        value={secondaryShowStatus}
                                    >
                                        <Radio value={0}>显示</Radio>
                                        <Radio value={1}>隐藏</Radio>
                                    </Radio.Group>
                                </div>

                                <Descriptions>
                                    <Descriptions.Item className="time-style" label="追评时间">
                                        {detail.secondaryReviewTimeStr || '--'}
                                    </Descriptions.Item>
                                </Descriptions>
                                <div style={{ whiteSpace: 'pre-line', lineHeight: 1.8 }}>
                                    {detail.secondaryContent
                                        ? detail.secondaryContent.replace(/ /g, '\u00a0')
                                        : '--'}
                                </div>
                                {detail.secondaryPicList && isArray(detail.secondaryPicList) ? (
                                    <div>
                                        {detail.secondaryPicList.map(
                                            (item: any, index: React.Key) => (
                                                <div
                                                    key={index}
                                                    className="image-box"
                                                    onClick={() => handlePreview(item)}
                                                >
                                                    <Image imageurl={item!} {...ImageProps} />
                                                </div>
                                            )
                                        )}
                                    </div>
                                ) : null}
                            </Card>
                        )}

                        <DetailTitle
                            label={'评论记录'}
                            dic={` 显示 ${reply.showCount ?? '0'} 条，隐藏 ${reply.hideCount ??
                                '0'} 条`}
                        />
                        {isArray(replyList) && replyList.length ? (
                            <div>
                                {replyList.map((item: any, index: any) => (
                                    <div className="comment-item" key={item.id}>
                                        <div className="user-content">
                                            <div className="user-info">
                                                <div className="name">{item.loginName}</div>
                                                <div className="time">{item.replyTimeStr}</div>
                                            </div>
                                            <div>{item.replyContent}</div>
                                        </div>

                                        <Radio.Group
                                            onChange={(e) => handleChangeReplyList(e, index)}
                                            value={item.replyStatus}
                                        >
                                            <Radio value={0}>显示</Radio>
                                            <Radio value={1}>隐藏</Radio>
                                        </Radio.Group>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                        )}
                        <div className="footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: '16px' }}
                                onClick={handelSave}
                            >
                                保存
                            </Button>
                            <Button onClick={goBack}>返回</Button>
                        </div>
                    </Card>
                </div>
            </Spin>
            <Modal
                visible={showPreview}
                footer={null}
                width={500}
                style={{ textAlign: 'center' }}
                onCancel={() => {
                    setShowPreview(false);
                    setTimeout(() => {
                        setPreviewImage('');
                    }, 20);
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                    }}
                >
                    <img style={{ width: '100%' }} src={previewImage} alt="" />
                </div>
            </Modal>
        </Fragment>
    );
};

export const SunbathingEdit = AntForm.create<CategoryFilterAttrTableProps>()(SunbathingEditDom);
